import React from 'react';
import { Button, Dialog, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';

import { Form } from '~/app/shared/components/Form';
import { useSignupDialogForm } from '../hooks/useSignupDialogForm';
import { useSignupDialogNavigation } from '../hooks/useSignupDialogNavigation';
import { SmartPayOnboardingSteps } from '../../../../types';
import { useSignupDialogOnboardingContext } from '../contexts/SignupDialogOnboardingContextProvider';

interface Props {
    initialData?: any;
    validationSchema?: any;
    updates?: any;
    children: React.ReactNode;
    onBack?: () => void;
    onNext?: () => void;
}

const SignupForm = ({
    initialData = undefined,
    validationSchema = undefined,
    updates = undefined,
    onBack = undefined,
    onNext = undefined,
    children,
}: Props) => {
    const { formData, onFormChange } = useSignupDialogForm();
    const { currentStep, nextStep, previousStep, stepsCount, currentStepIndex } = useSignupDialogNavigation();
    const { isLoadingOnboardingData } = useSignupDialogOnboardingContext();

    const onNextPressed = () => {
        onNext?.();
        nextStep();
    };

    const onBackPressed = () => {
        onBack?.();
        previousStep();
    };

    return (
        <Form
            initialData={initialData || { ...formData }}
            validationSchema={validationSchema}
            onChange={onFormChange}
            updates={updates}
            onSubmit={onNextPressed}
            className="my-3"
            skipNotifications>
            {children}

            <Dialog.Footer className="mt-6">
                <Group>
                    {(currentStep !== SmartPayOnboardingSteps.SUCCESS || onBack) && (
                        <Button onClick={onBackPressed}>
                            {currentStep === SmartPayOnboardingSteps.OVERVIEW ? <Trans>Close</Trans> : <Trans>Back</Trans>}
                        </Button>
                    )}
                    <Button appearance="primary" type="submit" disabled={isLoadingOnboardingData}>
                        {currentStep === SmartPayOnboardingSteps.SUCCESS ? (
                            <Trans>Continue</Trans>
                        ) : currentStep === SmartPayOnboardingSteps.OVERVIEW ? (
                            <Trans>Start setup</Trans>
                        ) : stepsCount === currentStepIndex ? (
                            // This happens when there is an error in the onboarding call
                            <Trans>Close</Trans>
                        ) : (
                            <Trans>Next</Trans>
                        )}
                    </Button>
                </Group>
            </Dialog.Footer>
        </Form>
    );
};

export default SignupForm;
